import { render, staticRenderFns } from "./Incident-report.vue?vue&type=template&id=14f9faac"
import script from "./Incident-report.vue?vue&type=script&lang=js"
export * from "./Incident-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports